import { createRouter, createWebHistory } from 'vue-router'

// import user.js
import * as Public from '@/views/public'
const routes = [
  { path: '/',  name: 'LayoutHome',  component: Public.LayoutHome, 
    children:[
      {path: '',  name: 'HomeView',  component: Public.HomeView,},
      {path: 'contact',  name: 'ContactView',  component: Public.ContactView,},
      {path: 'apropos',  name: 'AproposView',  component: Public.AproposView,},
      {path: 'services',  name: 'ServiceView',  component: Public.ServiceView,},
      {path: 'partenaires',  name: 'PartenairesView',  component: Public.PartenairesView,},
      {path: 'formations',  name: 'FormationView',  component: Public.FormationView,},
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
export default router
